import { Components, Theme } from "@mui/material/styles";

export const MuiCssBaseline = (theme: Theme) =>
  ({
    MuiCssBaseline: {
      styleOverrides: {
        code: {
          padding: theme.spacing(0.25, 0.5),
          backgroundColor: theme.palette.code.background,
          borderRadius: theme.shape.borderRadius,
        },
      },
    },
  }) satisfies Components<Theme>;
